import { BaseState } from '@ve/services/getStore/types';
import { Store } from 'vuex';
import getStore from '@ve/services/getStore/getStore';
import _ from 'underscore';
import { DepartureCity } from '@ve/types';

export default ({
                    model,
                }: {
    model: Backbone.Model
}): Store<BaseState> => getStore({
    name: 'mapForAlternativeSearch',
    backboneMap: [
        {
            fields: [{
                tourProducts: {
                    field: 'syncTourProducts',
                    action: (model: never, syncTourProducts: any) => syncTourProducts?.length,
                } as any,
            },
            {
                prevDepartureCity: {
                    field: 'searchData',
                    action: (model: never, searchData: any) => ({
                            name: searchData?.get('departureCity')?.get('name'),
                            id: searchData?.get('departureCity')?.get('id'),
                        }),
                } as any,
            },
            'loadingState',
            ],
            model,
        },
    ],
    storeOptions: {
        state: {
            directoryDepartureCities: null,
            visibleBanner: false,
            searchWasStart: false,
            idDefaultDepartureCity: 2, // id Москвы
            idCurrentDepartureCity: 2,
            isAlternativeSearchStop: false,
            visibleBannerByMap: true,
            emptyDepartureCities: {},
        },
        mutations: {
            setDefaultState(state) {
                state.visibleBanner = false;
                state.tourProducts = 0; // поле которое связывается с backbone полем SyncProducts
                state.isAlternativeSearchStop = false;
                state.searchWasStart = false;
                state.loadingState = 'loading';
                state.emptyDepartureCities = {};
                state.idCurrentDepartureCity = 2;
            },
            setDepatrureCities(state, directoryDepartureCities: DepartureCity[]) {
                state.directoryDepartureCities = directoryDepartureCities;
            },
            setDepartureCity(state, departureCityId: number) {
                state.idCurrentDepartureCity = departureCityId;
            },
            setVisibleBanner(state, flag: boolean) {
                state.visibleBanner = flag;
            },
            setStartSearch(state, flag: boolean) {
                state.searchWasStart = flag;
            },
            setStopSearch(state, flag: boolean) {
                state.isAlternativeSearchStop = flag;
            },
            addEmptyCities(state, dpartureCity: DepartureCity) {
                const { id, name } = dpartureCity;
                state.emptyDepartureCities[id] = name;
            },
            toogleVisibleBannerByMap(state) {
                state.visibleBannerByMap = !state.visibleBannerByMap;
            },
            setPrevDeparture(state, dpartureCity: DepartureCity) {
                const { id } = dpartureCity;
                if (id !== state.idDefaultDepartureCity) {
                    state.prevDepartureCity = dpartureCity;
                }
            },
        },
        actions: {},
        getters: {
            getAvailableCities(state) {
                const availableCtitesId = [2, 29, 64, 25, 53, 1]; // Москва - Казань - Самара - Екатеринбург - Новосибирсик - Санкт-Петербург
                const { directoryDepartureCities } = state;
                const massiveAvalibleCities = directoryDepartureCities?.filter((city: DepartureCity) => {
                    const isCityAvalible = availableCtitesId?.includes(city.id);
                    if (isCityAvalible) {
                        const { id, name } = city;
                        return {
                            id,
                            name,
                        };
                    }
                });
                return massiveAvalibleCities;
            },
            getAvilableCityWithoutCurrentCity(state, getters) {
                const avalibleCities = getters.getAvailableCities;
                const avalibleCitiesWithoutCurrentCity = avalibleCities?.filter((city: DepartureCity) => state.idCurrentDepartureCity !== city.id);
                return avalibleCitiesWithoutCurrentCity;
            },
            getAvilableCitiesWithoutEmptyDepartures(state, getters) {
                const { emptyDepartureCities } = state;
                const { getAvilableCityWithoutCurrentCity } = getters;

                const availableCitiesWithoutPrevDeparture = getAvilableCityWithoutCurrentCity?.filter((city: DepartureCity) => {
                    const { id } = city;
                    const isIdCityIncludesInEmptyDeparture = id in emptyDepartureCities;
                    if (!isIdCityIncludesInEmptyDeparture) {
                        return city;
                    }
                });

                return availableCitiesWithoutPrevDeparture;
            },
            getNameCurrentDepartureCity(state, getters) {
                const { getAvailableCities } = getters;
                const curentDepartureCity = getAvailableCities?.find((deparutreCity: DepartureCity) => deparutreCity.id === state.idCurrentDepartureCity);
                return curentDepartureCity?.name;
            },
            getNameDefaultDepartureCity(state, getters) {
                const { getAvailableCities } = getters;
                const defaultDepartureCity = getAvailableCities?.find((deparutreCity: DepartureCity) => deparutreCity.id === state.idDefaultDepartureCity);
                return defaultDepartureCity?.name;
            },
        },
    },
});